import { render, staticRenderFns } from "./Structure_TabsRight.vue?vue&type=template&id=7a0a158a&"
import script from "./Structure_TabsRight.vue?vue&type=script&lang=js&"
export * from "./Structure_TabsRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports